import { render, staticRenderFns } from "./SeanceCustomerPackages.vue?vue&type=template&id=41dfd198&"
import script from "./SeanceCustomerPackages.vue?vue&type=script&lang=js&"
export * from "./SeanceCustomerPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports